import { useState } from "react";
import {
  PlansApi,
  ResponseGetPlanInfoDetailResponse,
  RequestGetPlanInfoDetailRequest,
  PlansGetPlansInfoDetailPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetPlanInfoDetail = () => {
  const [planInfoDetail, setPlanInfoDetail] =
    useState<ResponseGetPlanInfoDetailResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchPlanInfoDetail = async (
    requestParams: RequestGetPlanInfoDetailRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: PlansGetPlansInfoDetailPostRequest = {
        req: requestParams,
      };

      const api = new PlansApi(config);
      const response = await api.plansGetPlansInfoDetailPost(request);
      setPlanInfoDetail(response);
      return response;
    } catch (err) {
      setError("プラン詳細の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { planInfoDetail, fetchPlanInfoDetail, error, isLoading };
};
